import { AuthGuard } from './auth-guard.service';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';

@Injectable()
export class RoleAuthGuard implements CanActivate {

    constructor(private auth: AuthService, private router: Router) {

    }



    canActivate(route: ActivatedRouteSnapshot): boolean {
        var hasRole = false;
        if (this.auth.isAuthenticated()) {
            if (route.data.requiredRoles) {
                route.data.requiredRoles.forEach((e: any) => {
                    if (this.auth.isInRole(e))
                        hasRole = true;
                });
            }
            if (route.data.membersOnly){
                // console.log("Members only triggered");
                hasRole = true;
            }
        }
        // console.log("hasrole: "+hasRole);
        // console.log("required Roles: "+route.data.requiredRoles);
        if (!hasRole){
            this.router.navigate(["/home"]);
        }
        return hasRole;

    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Services/role-guard.service.ts